import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import LegacyGone from "@/components/LegacyGone";

export const Route = createFileRoute("/wp-content/$")({
  head: () => pageHead("Page No Longer Available", "This page was part of a previous version of our website and has been permanently removed.", "/wp-content/$", false),
  component: LegacyGone,
});
